import AxiosWrapper from './AxiosWrapper';
import {
  appendServiceNameToURL,
} from '../resources/serviceURLs';
// import { serviceName } from '../resources/serviceConstants';

let isUnauthorized = false; // Flag to indicate if a 401 error has occurred
let isAlertShown = false; // Flag to indicate if the alert has been shown

const UseAxios = async (request, setLoading = () => {}) => {
  setLoading(true); // Set setLoading to true

  if (isUnauthorized) {
    return Promise.reject(new Error('Unauthorized. Please log in again.'));
  }

  const { service, method, url, payload, tag, headers, timeout, responseType } = request;
  let serviceURL = appendServiceNameToURL(service);
  // const servicePort = 8080;

  // Use different base URL for project management service
  // const baseUrl = process.env.REACT_APP_API_URL;
  // if (service === serviceName.PROJECT_MS) {
  //   baseUrl = process.env.REACT_APP_PROJECT_MGMT_API_URL || process.env.REACT_APP_API_URL;
  // }

  // if (process.env.NODE_ENV === 'production') {
  serviceURL = process.env.REACT_APP_API_URL + serviceURL + '/api' + url;
  // } else {
  //   serviceURL = baseUrl + `:${servicePort}` + serviceURL + url;
  // }

  const Wrapper = new AxiosWrapper(serviceURL, 'your-username', 'your-password', setLoading);
  const instance = Wrapper.axiosInstance;
  const authToken = Wrapper.getAuthToken();
  const hasActiveSession = !!authToken;

  // Ensure headers object exists before setting token
  const requestHeaders = headers || {};

  // Only add auth token if isAuthToken is true and we have a token
  if (requestHeaders?.isAuthToken && authToken) {
    requestHeaders.token = authToken;
    requestHeaders.Authorization = `Bearer ${authToken}`;
  }

  // **Fix for FormData**
  const isFormData = payload instanceof FormData;
  if (isFormData) {
    delete requestHeaders['Content-Type']; // Let Axios set it automatically
  }

  let axiosRequest = null;
  const axiosConfig = {
    headers: requestHeaders, // Keep isAuthToken flag for interceptor
    timeout: timeout || 180000, // Set default timeout to 180 seconds
    responseType: responseType || 'json', // Handle blob responses for images
  };

  switch (method) {
  case 'get':
    axiosRequest = instance.get(serviceURL, axiosConfig);
    break;
  case 'post':
    axiosRequest = instance.post(serviceURL, payload, axiosConfig);
    break;
  case 'put':
    axiosRequest = instance.put(serviceURL, payload, axiosConfig);
    break;
  case 'delete':
    axiosRequest = instance.delete(serviceURL, { ...axiosConfig, data: payload }); // Include payload in DELETE request
    break;
  case 'patch':
    axiosRequest = instance.patch(serviceURL, payload, axiosConfig);
    break;
  default:
    throw new Error(`Unsupported method: ${method}`);
  }

  return axiosRequest
    .then((response) => {
      return { tag, data: response.data, status: response?.status };
    })
    .catch((err) => {
      if (err.response?.status === 401) {
        if (hasActiveSession && !isAlertShown && window.location.pathname !== '/') {
          Wrapper.removeAuthToken();
          isAlertShown = true;
          isUnauthorized = true;
          alert('Session expired, login again');
          window.location.href = '/';
          return;
        }

        // Guest access can legitimately receive 401 for protected resources.
        // Do not show global session-expired alert when there is no active session.
        return { tag, data: err };
      } else {
        return { tag, data: err };
      }
    });
};

export default UseAxios;
